import { graphql } from "~/gql";

export const DELETE_NOTIFICATION_RULES = graphql(/* GraphQL */ `
  mutation DeleteNotificationRules($notificationRuleIds: [Float!]!) {
    deleteNotificationRules(notificationRuleIds: $notificationRuleIds) {
      notificationRuleIds
    }
  }
`);
